<template>
    <v-layout row wrap  :justify-space-around="window.width < 768 || !loaded" :justify-space-between="window.width >= 768 && loaded"> 
        <v-flex xs12 class="titulo-centro">
            <h2>PUBLICAÇÕES </h2>
            <div class="risquinho-centro"></div>
        </v-flex>
        <v-flex class="center-progress" xs1 v-if="!loaded">
            <v-progress-circular style="{margin-left: auto; margin-right: auto;}"
            indeterminate
            color="secondary"
            ></v-progress-circular>
        </v-flex>

        <div v-if="(loaded && id < 3) || (loaded && window.width > 767 && window.width < 1264) " v-for="(post, id) in posts" :key="id" sm12
                md12
                lg4>

            <v-flex d-flex elevation-3 xs12 class="flex-container round-card"
                sm12
                md12
                lg4
                >

                    <v-card  >
                        <v-img :src="post[1].img" :max-height="200" :min-height="200" :max-width="300" :min-width="300"></v-img>
                        
                        <v-card-title primary-title>
                            <div>
                                <div class="trunc-title">
                                        <strong v-line-clamp="3"> {{post[1].title}} </strong> 
                                </div>
                                <span class="grey--text"> {{post[1].date}} </span>
                            </div>
                        </v-card-title>


                        <v-card-text >
                            <span  class="mini-posts" v-html="post[1].content"></span> <br>
                        </v-card-text>

                        <v-card-actions>
                            <router-link :to="{ name: 'feedFrom', params: {postKey: post[0] } }" :postKey="posts[0]"  >
                                <v-btn outline color="secondary" flat class="white--text text-none" >Ler mais</v-btn>

                            </router-link>
                        </v-card-actions>
                    </v-card>
            </v-flex>
        </div>


        <v-flex class="ver-todas" xs12>
            <a href="/feed">
                <h6>
                    VER TODAS
                </h6> 
            </a>
        </v-flex>

    </v-layout>
</template>

<script>
import base from '../plugins/firebase'

export default {
    data() {
        return {
            posts: [],
            ref: base.database().ref("posts"),

            window: {
                width: 0,
                height: 0
            },

            dismissSecs: 5,
            dismissCountDown: 0,
            loaded: false
        }
    },

    created(){
        this.get()
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize)
    },

    methods: {
        get() {
            this.ref.orderByKey().limitToLast(4).once('value')
            .then(snapshot => {
                var result = snapshot.val()
                if(result != null){
                    
                    this.posts = Object.entries(result).reverse()
                }
                else {
                    this.posts = []
                }

                this.loaded = true
            })
        },

        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        }
    }

}
</script>

<style scoped>
.v-card__text {
    width: 300px !important;
    height: 60px !important;
    min-height: 50px !important;   
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 12px !important;
    padding-right: 12px !important;
    word-wrap: break-word;
    /* text-overflow: ellipsis; */
    overflow: hidden;
}

/* .round-card {
    margin-left: 20px;
    margin-right: 20px;
} */

@media (max-width: 576px){
    .round-card {
        margin-left: 20px;
        margin-right: 20px;
    }
} 

.v-card__title{
    padding: 12px !important;
}

.flex-container {
    position: relative;
    margin-top: 16px;
    max-width: 300px; 
    max-height: 420px; 
    min-height: 420px; 
    overflow: hidden;
    text-overflow: ellipsis;
}

.v-card__actions{
    padding-left: 12px !important;
    position: absolute;
    bottom: 4px;
}

.ver-todas{
    text-align: center;
    padding-top: 36px;
}

.ver-todas a{
    text-decoration: underline #6ba348 !important;
    color: #272727;
}

.ver-todas a:hover{
    color: #6ba348;
}

.trunc-title strong{
    word-break: unset !important;
}
</style>
